import dayjs from 'dayjs';

/** True when the meal date is today or in the future (orders allowed). */
export function isMealDateOrderable(value) {
	if (value == null || value === '') return true;
	const day = dayjs(value);
	if (!day.isValid()) return true;
	return !day.isBefore(dayjs(), 'day');
}

/** True when the calendar day is before today (view-only). */
export function isPastMealDay(day) {
	if (day == null) return false;
	const d = dayjs(day);
	if (!d.isValid()) return false;
	return d.isBefore(dayjs(), 'day');
}
